import useUser from "api/api-hooks/auth/useUser";
import useCreateRecord from "api/api-hooks/records/useCreateRecord";
import { useState } from "react";
import { Button, Input } from "reactstrap";
import QuickNoteRelatedTo from "./QuickNoteRelatedTo";

const TranscriptInput = ({ text, setText }) => (
  <Input
    placeholder="Enter text"
    type="textarea"
    rows={8}
    value={text}
    onChange={(e) => setText(e.target.value)}
  />
);

const AudioPreview = ({ recordingURL, text, setText }) => (
  <>
    <audio src={recordingURL} type="audio/webm" controls={true}></audio>
    <div className="my-3">See Transcription</div>
    <TranscriptInput text={text} setText={setText} />
  </>
);

const QuickNotePreview = ({
  recordingURL,
  onCancelTranscript,
  text,
  setText,
  fileData,
  setPage,
  setRecordID,
  setFileData,
  record, // If provided, will be added to the Activities Related To field.
}) => {
  const { user } = useUser();
  const { createRecord } = useCreateRecord();
  const [relatedTo, setRelatedTo] = useState([]);

  return (
    <div
      className="d-flex align-items-center flex-column py-3 px-4"
      style={{ fontSize: 14 }}
    >
      <div className="mb-2">
        {recordingURL ? "Preview Your Recording" : "Preview"}
      </div>
      {!recordingURL && <TranscriptInput text={text} setText={setText} />}
      {recordingURL && (
        <AudioPreview
          recordingURL={recordingURL}
          text={text}
          setText={setText}
        />
      )}
      <div className="d-flex justify-content-between w-100 mt-4">
        <Button
          size="sm"
          className="btn-icon-only"
          outline
          onClick={onCancelTranscript}
        >
          <i className="mdi mdi-chevron-left" />
        </Button>
        <QuickNoteRelatedTo relatedTo={relatedTo} setRelatedTo={setRelatedTo} />
        <Button
          color="primary"
          size="sm"
          onClick={saveQuickNote}
          style={{ width: 80 }}
          disabled={!text}
        >
          Save
        </Button>
      </div>
    </div>
  );

  function saveQuickNote() {
    setPage("saving-quick-note");

    const payload = {
      Name: user?.Name ? `Quick Note By ${user?.Name}` : `Quick Note`,
      Body: { RichText: text, PlainText: text },
      Type: "Note",
      Priority: "2 - Normal",
      Owners: [
        {
          id: user?.id,
          _ModuleAPIName: "Contacts",
          _RecordName: user?.Name,
        },
      ],
      Attachment: fileData
        ? [
            {
              File: fileData.fileURL,
              AltText: "audio",
              Name: "Quick Note Recording",
            },
          ]
        : null,
      Related:
        Array.isArray(relatedTo) && relatedTo?.length > 0
          ? relatedTo.map((x) => ({
              id: x?.id,
              _ModuleAPIName: x?._ModuleAPIName,
              _RecordName: x?._RecordName,
            }))
          : [],
    };

    // Related the current record to the Activity (Provided when using Submodules)
    if (record) {
      const recordID = record?._id || record?.id;

      if (!payload.Related.find((r) => r?.id === recordID)) {
        payload.Related.push({
          id: recordID,
          _ModuleAPIName: record?._ModuleAPIName,
          _RecordName: record?._RecordName,
        });
      }
    }

    createRecord({
      module: { Name: "Activities", APIName: "Activities" },
      payload: payload,
      onCreate: (record) => {
        setRecordID(record?.id);
        setFileData(null);
      },
    });
  }
};

export default QuickNotePreview;
